import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import "./components.css";
import CustomTooltip from "./CustomTooltip";
import { TextField, Tooltip } from "@mui/material";
import { useTranslation} from "react-i18next";

export default function TextfieldComponent(props) {
  const {t} = useTranslation();

  const {
    label,
    value,
    onChange,
    required,
    name,
    error,
    helperText,
    pattern,
    type,
    multiline,
    rows,
    prefix,
    tooltip,
    testId,
    disabled,
    autoFocus
  } = props;
 
  const handleChange = (e, v) => {
    // Check if the label contains "email" in any case
    if (/email/i.test(label)) {
      e.target.value = e.target.value.toLowerCase();
      onChange(e, v);
    } else {
      onChange(e, v);
    }
  };
  
  const returnValue = (data) => {
    if (prefix && isNaN(data)) {
      return 0.0;
    } else {
      return data;
    }
  };

  let firstFields = ["FirstName", "AddressLine1", "WhoReferredYou?"];

  React.useEffect(() => {
    const viewport = document.querySelector('meta[name=viewport]');
    const viewportContent = 'width=device-width, initial-scale=1, maximum-scale=1';
    
    if (viewport) {
      viewport.setAttribute('content', viewportContent);
    } else {
      const newViewport = document.createElement('meta');
      newViewport.name = 'viewport';
      newViewport.content = viewportContent;
      document.head.appendChild(newViewport);
    }
    return () => {
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1');
      }
    };
  }, []);

  return (
    <div className={multiline ? "textArea" : "flexAlignColumnClassName"} onClick={(e) => { e.preventDefault() }}>
      <InputLabel
        htmlFor="outlined-adornment-amount"
        required={required}
        className="labelClassName alignRowClassName flex-start"
      >
        <span>{t(label)}</span>
        {tooltip && (
          <CustomTooltip title={t(tooltip)}>
            <span className="tooltipInfoIcon">i</span>
          </CustomTooltip>
        )}
      </InputLabel>
      <TextField
        data-testid={testId}
        name={name}
        type={type}
        autoComplete="off"
        id="outlined-adornment-amount"
        className="textFieldInputComponent"
        style={{ 
          height: multiline ? "100%" : "auto",
          fontSize: '16px'
         }}
        value={returnValue(value)}
        onAnimationStart={(e) => props.onLoad(e)}
        onChange={(e, v) => handleChange(e, v)}
        required={required}
        multiline={multiline}
        rows={rows || 4}
        maxRows={rows}
        inputProps={{ 
          pattern: pattern,
          style: { fontSize: '16px' }
        }}
        disabled={disabled}
        InputProps={{
          classes: {
            root: error
              ? "outlinedErrorInputRoot"
              : multiline
                ? "multilineOutlinedInputRoot"
                : disabled ? "disableInputRoot outlinedInputRoot" : "outlinedInputRoot",
            focused: error
              ? "outlinedErrorInputFocused"
              : "outlinedInputFocused",
            notchedOutline: "outlinedInput",
          },
          startAdornment: prefix && (
            <div style={{ paddingRight: 5 }}>{prefix}</div>
          ),
          style: { fontSize: '16px' }
        }}
        FormHelperTextProps={{
          classes: {
            root: "helperTextClassName",
          },
        }}
        helperText={t(helperText)}
        error={t(error)}
        autoFocus={firstFields.includes(name)}
      />
    </div>
  );
}
